import Sidebar from "@/components/Sidebar";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

export default function AppLayout() {
  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      <Sidebar />
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <div className="p-6 md:p-8 max-w-[1400px] mx-auto anim-in">
          <Outlet />
        </div>
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
